import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router'
import { Observable } from 'rxjs'
import { map, take } from 'rxjs/operators'

import { ConfigurationService } from '../shared/services/configuration.service'
import { resolveMobileAppRedirect } from 'src/app/shared/utils/mobile-app-redirect'

@Injectable({
  providedIn: 'root'
})
export class MobileCustomerAccessGuard
  implements CanActivate, CanActivateChild
{
  constructor(
    private configurationService: ConfigurationService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.configurationService.isRouteAllowedOnMobileApp$(state.url).pipe(
      take(1),
      map((isAllowed) =>
        isAllowed ? true : this.router.parseUrl(resolveMobileAppRedirect())
      )
    )
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state)
  }

}
